import { __awaiter, __extends, __generator } from "tslib";
import { BaseStockModel } from '@/core/standard/BaseStockModel';
import StockProductService from '@/modules/stocks/StockProductService';
var stock = {
  uuid: '',
  name: '',
  location: '',
  description: '',
  warehouse_uuid: '',
  extras: {}
};

var StockProductModel =
/** @class */
function (_super) {
  __extends(StockProductModel, _super);

  function StockProductModel() {
    var _this = _super.call(this, stock, StockProductService) || this;

    _this.modelName = 'StockProduct';
    _this.request = 'JSON';
    _this.uniqueField = 'uuid';
    return _this;
  }

  StockProductModel.prototype.sendDiscount = function (data, toast, toastConfig) {
    return __awaiter(this, void 0, void 0, function () {
      var payload, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            payload = {
              method: 'PUT',
              query: data
            };
            return [4
            /*yield*/
            , this.service.request(payload)];

          case 1:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, 'Ok', null)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return StockProductModel;
}(BaseStockModel);

export default StockProductModel;